/**
 * staff_roles.framework_keys: null or [] = all frameworks; else JSON array of
 * keys (e.g. ["dpdp_2023"]).
 *
 * A role is shown when it is unrestricted, or when at least one of its
 * framework_keys is one the customer is subscribed to.
 *
 * @param {string[]|null} frameworkKeys - the role's framework_keys
 * @param {string[]} subscribedFrameworkKeys - framework keys the customer is subscribed to
 */
export function roleMatchesFrameworkFilter(frameworkKeys, subscribedFrameworkKeys) {
  const unrestricted =
    frameworkKeys == null ||
    (Array.isArray(frameworkKeys) && frameworkKeys.length === 0);

  if (unrestricted) return true;

  const subscribed = Array.isArray(subscribedFrameworkKeys)
    ? subscribedFrameworkKeys
    : [];

  return (
    Array.isArray(frameworkKeys) &&
    frameworkKeys.some((key) => subscribed.includes(key))
  );
}
